// extracted by mini-css-extract-plugin
module.exports = {"root":"imageitem_root__3hSy5","item":"imageitem_item__1Feq7","deleteBtn":"imageitem_deleteBtn__wJQLU","caption":"imageitem_caption__24fU_"};